import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { EditorModule } from "@tinymce/tinymce-angular";
import { NgbModule, NgbAlertModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
//import { AuthModule } from './auth/auth/auth.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { TopbarComponent } from './topbar/topbar.component';
import { HeroComponent } from './hero/hero.component';
import { InmaterialComponent } from './inmaterial/inmaterial.component';
import { Mapa2Component } from './mapa2/mapa2.component';
import { SectoresbannerComponent } from './sectoresbanner/sectoresbanner.component';
import { MapaolComponent } from './mapaol/mapaol.component';
import { MapaInmaterialComponent, NgbdModalContent } from './mapa-inmaterial/mapa-inmaterial.component';
import { SeccionInmaterialComponent } from './seccion-inmaterial/seccion-inmaterial.component';
import { FooterComponent } from './footer/footer.component';
import { SectorDetailComponent } from './sector-detail/sector-detail.component';
import { HomeCarouselComponent } from './home-carousel/home-carousel.component';
import { SectorCarouselComponent } from './sector-carousel/sector-carousel.component';
import { SeccionHomeComponent } from './seccion-home/seccion-home.component';
import { SeccionCatalogacionComponent } from './seccion-catalogacion/seccion-catalogacion.component';
import { SeccionPlanmaestroComponent } from './seccion-planmaestro/seccion-planmaestro.component';
import { ListaFichasInmaterialesComponent } from './seccion-inmaterial/lista-fichas-inmateriales/lista-fichas-inmateriales.component';
import { FormFichaInmaterialComponent } from './seccion-inmaterial/form-ficha-inmaterial/form-ficha-inmaterial.component';
import { SeccionPostulanteComponent } from './components/seccionPostulante/seccionPostulante.component';
import { FormPostulanteComponent } from './components/seccionPostulante/FormPostulante/FormPostulante.component';
import { FormPostulanteReactivoComponent } from './components/seccionPostulante/FormPostulanteReactivo/FormPostulanteReactivo.component';
import { FormProductoReactivoComponent } from './components/seccionPostulante/FormProductoReactivo/FormProductoReactivo.component';
import { FormProductoReactivoDinamicoComponent } from './components/seccionPostulante/FormProductoReactivoDinamico/FormProductoReactivoDinamico.component';
import { FormPostulanteNestedComponent } from './components/seccionPostulante/FormPostulanteNested/FormPostulanteNested.component';


//SERVICES
import { FichaInmaterialService } from './services/ficha-inmaterial.service';
import { SlideService } from './services/slide.service';
import { SectorService } from './services/sector.service';
import { SectorDetalleService } from './services/sector-detalle.service';
import { FichaService } from './services/ficha.service';
import { PostulanteService } from './services/postulante.service';
import { PostulanteApiRestService } from './services/postulanteApiRest.service';
import { AccountService } from './services/account.service';
//import { LoginComponent } from './auth/components/login/login.component';
//import { RegisterComponent } from './auth/components/register/register.component';
import { MapboxInmaterialComponent } from './components/mapbox-inmaterial/mapbox-inmaterial.component';
import { MapboxFichaDetalleComponent } from './components/mapbox-ficha-detalle/mapbox-ficha-detalle.component';
import { ModalResumenFichaComponent } from './components/ModalResumenFicha/ModalResumenFicha.component';
import { ModalInmaterialComponent } from './components/ModalInmaterial/ModalInmaterial.component';
import { MapboxPlanmaestroComponent } from './components/mapbox-planmaestro/mapbox-planmaestro.component';
import { GerenciaComponent } from './components/gerencia/gerencia.component';
import { MonoComponent } from './mono/mono.component';
import { RequisitosComponent } from './requisitos/requisitos.component';
import { ContactoComponent } from './contacto/contacto.component';
import { SistemasComponent } from './sistemas/sistemas.component';
import { SocialComponent } from './social/social.component';
import { VerificacionComponent } from './verificacion/verificacion.component';
import { CatalogacionComponent } from './catalogacion/catalogacion.component';
import { NosotrosComponent } from './nosotros/nosotros.component';
import { TomoIComponent } from './tomo-i/tomo-i.component';
import { TomoIIComponent } from './tomo-ii/tomo-ii.component';
import { ReligiososComponent } from './religiosos/religiosos.component';
import { AmbientesUrbanosComponent } from './ambientes-urbanos/ambientes-urbanos.component';
import { FototecaComponent } from './fototeca/fototeca.component';
import { LibroComponent } from './libro/libro.component';
import { LibroriesgosComponent } from './libroriesgos/libroriesgos.component';
import { GestionriesgosComponent } from './gestionriesgos/gestionriesgos.component';
import { LeandroComponent } from './leandro/leandro.component';
import { TuyrotupacComponent } from './tuyrotupac/tuyrotupac.component';
import { LeandroalviniaComponent } from './leandroalvinia/leandroalvinia.component';
import { GuiaComponent } from './guia/guia.component';


const routes: Routes = [
  { path: '', redirectTo: '/inicio', pathMatch: 'full'},
  { path: 'inicio', component: SeccionHomeComponent },
  { path: 'catalogacion', component: SeccionCatalogacionComponent },
  { path: 'inmaterial', component: SeccionInmaterialComponent },
  { path: 'planmaestro', component: SeccionPlanmaestroComponent},
  { path: 'sectorgchc/:id', component: SectorDetailComponent },
  { path: 'manfinmateriales', component: ListaFichasInmaterialesComponent },
  { path: 'catfichainmaterial/form', component: FormFichaInmaterialComponent},
  { path: 'catfichainmaterial/form/:id', component: FormFichaInmaterialComponent },
  { path: 'postulantes', component: SeccionPostulanteComponent},
  { path: 'postulantes/form', component: FormPostulanteComponent },
  { path: 'postulantes/form/:id', component: FormPostulanteComponent},
  { path: 'postulantes/formreactivo', component: FormPostulanteReactivoComponent},
  { path: 'productos/formreactivo', component: FormProductoReactivoComponent},
  { path: 'productos/formreactivodinamico', component: FormProductoReactivoDinamicoComponent},
  { path: 'postulantes/formnested', component: FormPostulanteNestedComponent},
  { path: 'postulantes/formnested/:id', component: FormPostulanteNestedComponent},
  { path: 'gerencia', component: GerenciaComponent},
  { path: 'requisitos', component: RequisitosComponent},
  { path: 'contacto', component: ContactoComponent},
  { path: 'nosotros', component: NosotrosComponent},
  { path: 'sistemas', component: SistemasComponent},
  { path: 'social', component: SocialComponent},
  { path: 'verificacion', component: VerificacionComponent},
  { path: 'comp-catalogacion', component: CatalogacionComponent},
  { path: 'tomo-uno', component: TomoIComponent},
  { path: 'tomo-dos', component: TomoIIComponent},
  { path: 'inmuebles-religiosos', component: ReligiososComponent},
  { path: 'ambientes-urbanos', component: AmbientesUrbanosComponent},
  { path: 'fototeca', component: FototecaComponent},
  { path: 'libro', component: LibroComponent},
  { path: 'libroriesgos', component: LibroriesgosComponent},
  { path: 'gestionriesgos', component: GestionriesgosComponent},
  { path: 'leandro', component: LeandroComponent},
  { path: 'tuyrotupac', component: TuyrotupacComponent},
  { path: 'leandroalvinia', component: LeandroalviniaComponent},
  { path: 'guia', component: GuiaComponent},
  //-----------------------------------------
  //{ path: 'login', component: LoginComponent},
  //{ path: 'register', component: RegisterComponent},

]


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    TopbarComponent,
    HeroComponent,
    InmaterialComponent,
    SectoresbannerComponent,

    //MAPAS
    MapaolComponent,
    MapaInmaterialComponent,
    Mapa2Component,
    MapboxInmaterialComponent,
    MapboxFichaDetalleComponent,
    MapboxPlanmaestroComponent,
    //OTROS
    FooterComponent,
    SectorDetailComponent,
    HomeCarouselComponent,
    SectorCarouselComponent,
    //SECCIONES
    SeccionHomeComponent,
    SeccionCatalogacionComponent,
    SeccionPlanmaestroComponent,
    SeccionInmaterialComponent,
    //FORMS
    FormFichaInmaterialComponent,
    ListaFichasInmaterialesComponent,
    FormPostulanteComponent,
    SeccionPostulanteComponent,
    FormPostulanteReactivoComponent,
    FormProductoReactivoComponent,
    FormProductoReactivoDinamicoComponent,
    FormPostulanteNestedComponent,
    // MODALS
    NgbdModalContent,
    ModalResumenFichaComponent,
    ModalInmaterialComponent,
    GerenciaComponent,
    MonoComponent,
    RequisitosComponent,
    ContactoComponent,
    SistemasComponent,
    SocialComponent,
    VerificacionComponent,
    CatalogacionComponent,
    NosotrosComponent,
    TomoIComponent,
    TomoIIComponent,
    ReligiososComponent,
    AmbientesUrbanosComponent,
    FototecaComponent,
    LibroComponent,
    LibroriesgosComponent,
    GestionriesgosComponent,
    LeandroComponent,
    TuyrotupacComponent,
    LeandroalviniaComponent,
    GuiaComponent,

    //LoginComponent,
    //RegisterComponent
   ],
  imports: [
    //ENRUTAMIENTO
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top'
   }),
    BrowserModule,
    //modulo para servicios API-REST
    HttpClientModule,
    BrowserAnimationsModule,
    CarouselModule,
    //FORMS
    FormsModule,
    ReactiveFormsModule,
    CKEditorModule,
    EditorModule,
    //Modulo Ng-Bootstrap
    NgbModule,
    NgbAlertModule,
    NgbPaginationModule
    //AuthModule

  ],
  providers: [
    SlideService,
    SectorService,
    SectorDetalleService,
    FichaInmaterialService,
    FichaService,
    PostulanteService,
    PostulanteApiRestService,
    AccountService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
